
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeSpeedCraftOutlined as ObiVesselTypeSpeedCraftOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-speed-craft-outlined.js';
 
 
 

 
 export const ObiVesselTypeSpeedCraftOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-speed-craft-outlined',
   elementClass: ObiVesselTypeSpeedCraftOutlinedElement,
   events: {
     
   }
  });
 
 